// extracted by css-extract-rspack-plugin
export default {"root":"DeO5L","labelWrapper":"vV7zR","track":"n8uLc","thumb":"Czmin","body":"UNSWZ","label":"sGskH","description":"hS7Mq","error":"WQ_qq"};